import React, { forwardRef } from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import PersonIcon from '@/components/icons/Person';
import { Profile, User } from '@bimdata/definitions/dto';

type CustomAvatarProps = {
  source?: string | null | false;
  profile?: Profile | User | null | string;
} & AvatarProps;

export default forwardRef<HTMLDivElement, CustomAvatarProps>(({ source, profile, ...props }, ref) => {
  if (source) {
    return <Avatar ref={ref} src={source} {...props}/>;
  }
  if (typeof profile === 'string') {
    return <Avatar ref={ref} {...props}>{profile}</Avatar>
  }
  if (profile?.name) {
    return <Avatar ref={ref} {...props}>{profile.name[0].toUpperCase()}</Avatar>
  }
  if (profile?.lastName) {
    return <Avatar ref={ref} {...props}>{profile.lastName[0].toUpperCase()}</Avatar>
  }
  if ((profile as User)?.fullName) {
    return <Avatar ref={ref} {...props}>{(profile as User).fullName[0].toUpperCase()}</Avatar>
  }
  return <Avatar ref={ref} {...props}><PersonIcon size={16} fill='#6B778C'/></Avatar>;
});